import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36393774"),n=n(),_popScopeId(),n)
const _hoisted_1 = { slot: "content" }

import {
  IonAccordion,
  IonAccordionGroup,
  IonButton,
  IonCheckbox,
  IonIcon,
  IonItem,
  IonLabel
} from "@ionic/vue";
import { layersOutline } from "ionicons/icons";
import { Map } from "maplibre-gl";
import { ref } from "vue";
import { Monitoring } from "@/utilities/monitoring";


export default /*#__PURE__*/_defineComponent({
  __name: 'GeoLayerToggle',
  props: {
  map: {
    type: Map,
    required: true
  },
  isPreloadVisible: {
    type: Boolean,
    required: true
  },
  mapStyle: {
    type: Object,
    required: true
  }
},
  setup(__props) {

const props = __props;



const isLayerSwitcherOpen = ref(false);
const mapStyleMultilayer = ref(props.mapStyle);
const displayedLayerStructure: any = ref({});

function initDisplayedLayerStructure() {
  try {
    Monitoring.setContext("mapStyle", { name: mapStyleMultilayer.value.name });

    const toggleGroups = mapStyleMultilayer.value?.layer_toggle_groups ?? {};
    if (!Object.keys(toggleGroups).length) {
      Monitoring.log("No layer_toggle_groups found in map style");
    }
    Object.entries(toggleGroups).forEach(([groupId, layerDefs]: [string, any]) => {
      displayedLayerStructure.value[groupId] = [];

      layerDefs.forEach((layerDef: any) => {
        //Coded so that old are supported as well as new layer toggle groups
        const isObject = typeof layerDef === "object" && layerDef !== null;
        const sourceId = isObject ? layerDef.id : layerDef;
        const label = isObject ? layerDef.label ?? sourceId : sourceId;
        const defaultChecked = isObject ? layerDef.defaultChecked : true; 
        const layers = mapStyleMultilayer.value.layers.filter((layer: any) => layer.source === sourceId);

        if (layers.length > 0) {
          const layerVisible = layers[0].layout?.visibility !== "none";
          const checked = typeof defaultChecked === "boolean" ? defaultChecked : layerVisible;

          displayedLayerStructure.value[groupId].push({
            id: sourceId,
            label,
            checked,
            layers
          });
        } else {
          Monitoring.withScope((scope) => {
            const context = { sourceId };
            scope.setContext("sources", context);
            Monitoring.error("No layers found for given source id", context);
          });
        }
      });
    });
  } catch (error: any) {
    Monitoring.withScope((scope) => {
      Monitoring.chainError("Error while initializing displayedLayerStructure", error);
    });
  } finally {
    Monitoring.clearContexts();
  }
}

function toggleLayer(source: any) {
  source.checked = !source.checked;
  mapStyleMultilayer.value.layers.forEach((layer: any) => {
    if (layer.source === source.id) {
            props.map.setLayoutProperty(layer.id, "visibility", source.checked ? "visible" : "none");
    }
  });
}

initDisplayedLayerStructure();

props.map?.on("click", () => {
  if ( isLayerSwitcherOpen.value ) {
    isLayerSwitcherOpen.value = false;
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonButton), {
      class: _normalizeClass(`${__props.isPreloadVisible ? 'pos-two' : 'pos-one'} layer-button`),
      size: "small",
      color: "light",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isLayerSwitcherOpen.value = !isLayerSwitcherOpen.value))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonIcon), {
          slot: "icon-only",
          icon: _unref(layersOutline)
        }, null, 8, ["icon"])
      ]),
      _: 1
    }, 8, ["class"]),
    _withDirectives(_createVNode(_unref(IonAccordionGroup), {
      class: _normalizeClass(`${__props.isPreloadVisible ? 'pos-three' : 'pos-two'} layer-switcher`)
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(displayedLayerStructure.value), (groupId) => {
          return (_openBlock(), _createBlock(_unref(IonAccordion), {
            key: groupId,
            value: groupId
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonItem), {
                slot: "header",
                color: "light"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(groupId), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedLayerStructure.value[groupId], (source) => {
                  return (_openBlock(), _createBlock(_unref(IonItem), {
                    key: source.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCheckbox), {
                        checked: source.checked,
                        onIonChange: ($event: any) => (toggleLayer(source))
                      }, null, 8, ["checked", "onIonChange"]),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(source.label), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["class"]), [
      [_vShow, isLayerSwitcherOpen.value]
    ])
  ], 64))
}
}

})